import { motion } from "framer-motion";
import { PhoneCall, CalendarClock, PencilLine, Phone } from "lucide-react";
import { PageHero, reveal } from "@/components/site/primitives";
import Seo from "@/components/site/Seo";
import LeadForm from "@/components/site/LeadForm";
import { CONTACT } from "@/lib/data";
import { useContent } from "@/i18n/content";
import { useI18n } from "@/i18n";

const ICONS = [PhoneCall, CalendarClock, PencilLine];

export default function QuickQuote() {
  const { t } = useI18n();
  const { PROCESS_STEPS } = useContent();
  const quoteJsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: t("qq.seoTitle"),
    description: t("qq.seoDesc"),
    url: "https://eewaste.com/quick-quote",
    mainEntity: { "@id": "https://eewaste.com/#business" },
  };
  return (
    <>
      <Seo
        title={t("qq.seoTitle")}
        description={t("qq.seoDesc")}
        path="/quick-quote"
        jsonLd={quoteJsonLd}
      />
      <PageHero
        crumb={t("qq.crumb")}
        eyebrow={t("qq.eyebrow")}
        title={t("qq.title")}
        highlight={t("qq.highlight")}
        subtitle={t("qq.subtitle")}
      />

      <section className="relative bg-[#FBFAF8] py-24">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-start">
          <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            <a href={CONTACT.phoneHref} className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-[#E7E5DF] shadow-soft hover:border-emerald-600/50 transition-colors mb-8" data-testid="quote-phone">
              <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#0E3B3B] text-emerald-300"><Phone size={22} /></span>
              <span>
                <span className="block font-mono-tech text-[11px] uppercase tracking-widest text-slate-500">{t("qq.callToday")}</span>
                <span className="block font-display font-bold text-xl text-[#0B0F14]">{CONTACT.phone}</span>
              </span>
            </a>
            <h3 className="font-display font-bold text-lg text-[#0B0F14] mb-5">{t("qq.whatsNext")}</h3>
            <div className="space-y-5">
              {PROCESS_STEPS.map((s, i) => {
                const Icon = ICONS[i];
                return (
                  <div key={s.step} className="flex items-start gap-4">
                    <span className="grid place-items-center w-10 h-10 rounded-xl bg-emerald-600/10 text-emerald-700 shrink-0"><Icon size={20} /></span>
                    <div>
                      <h4 className="font-semibold text-[#0B0F14]">{s.title}</h4>
                      <p className="text-slate-600 text-sm mt-1">{s.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>
          <motion.div variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            <LeadForm heading={t("qq.formHeading")} />
          </motion.div>
        </div>
      </section>
    </>
  );
}
